<template>
  <div class="al">
    <div class="titre">
      Application mobile (Android & iOS)
    </div>
    <div class="title3 md:mt-10 mt-4">
      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          enrôlement pour les nouveaux et les anciens clients de la compagnie ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          devis instantanés et souscription aux  différents produits d'assurance
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          souscription, renouvellement, prorogation et paiement de la prime par Mobile Money ou par cartes bancaires ou tout autre moyen de paiement intégrable ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          gestion à distances des contrats d'assurance ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          notifications et rappels des échéances de assurances ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          historiques des paiements ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          chat instantané pour assistance ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          déclaration de sinistres ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          suivi du traitement des dossiers de sinistres ;
        </div>
      </div>

      <div class="flex">
        <span>.</span>
        <div class="pr-6">
          Vérification de la validité des attestation par code USSD par la police ;
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";
.titre{
  font-weight: 800;
  font-size: 36px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $black
}
.titre1{
  font-weight: 800;
  font-size: 24px;
  line-height: 150%;
  letter-spacing: 0.01em;
  color: $dev_green;
}
.title3{
  font-weight: 400;
  font-size: 24px;
  line-height: 38.4px;
  color: $black;
}
span{
  font-size: 30px;
  font-weight: bold;
  margin-right: 10px;
}
@media screen and (max-width: 600px){
  .titre{
    font-size: 20px;
  }
  .titre1{
    font-size: 14px;
  }
  .title3, span{
    font-size: 14px;
    line-height: 32px;
  }
}
@media screen and (min-width: 701px) and (max-width: 1024px){
  .titre{
    font-size: 30px;
  }
  .title3{
    font-size: 22px;
  }
  .titre1{
    font-size: 20px;
  }
  .blocc {
    padding: 30px;
  }
}
</style>
